import { CommonModule } from '@angular/common';
import {
  Component, OnDestroy, computed, inject,
} from '@angular/core';
import { RouterModule } from '@angular/router';

import { ToastComponent, ToastService } from '@instaclause-webapp/shared-ui';
import { Subscription } from 'rxjs';

import { BottomComponent } from '../../ui/bottom/bottom.component';
import { MenuComponent } from '../../ui/menu/menu.component';

@Component({
  selector: 'app-main-layout',
  imports: [
    CommonModule,
    RouterModule,
    ToastComponent,
    MenuComponent,
    BottomComponent,
  ],
  templateUrl: './main-layout.component.html',
  styleUrl: './main-layout.component.scss',
})
export class MainLayoutComponent implements OnDestroy {
  openToastsCount = computed(() => this.toastService.toasts().length);

  private subscription = new Subscription();
  private toastService = inject(ToastService);

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
